// removed by extract-text-webpack-plugin
module.exports = {"SectionHeader":"SectionHeader---3I5zG"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/Person/ActivitySection/SectionHeader.styl
// module id = klvG
// module chunks = 89